<template>
    <el-dialog
        :visible.sync="show_store_section_modal"
        custom-class="store-section-edit-modal"
        top="0"
        width="95%"
        :lock-scroll="true"
        :before-close="hideStoreSectionEditModal"
    >
        <div style="display: flex; justify-content: space-between" class="mb-2">
			<h2 class="popup-title">Add/Edit Store Section</h2>
            <div class="pt-2">
                <el-button
                    icon="el-icon-close"
                    size="mini"
                    circle
                    @click="hideStoreSectionEditModal"
                ></el-button>
            </div>
		</div>

        <div class="my-4">
            <div class="section-name">{{ store_section_details.name }}</div>
        </div>

        <el-row :gutter="20">
            <el-col
                :span="12"
            >
                <h4 class="mb-2">Coverage Activities</h4>
                <el-row v-if="groupedCoverageSections[store_section_details.id]" :gutter="20">
                    <el-col
                        v-for="(item, index) in groupedCoverageSections[store_section_details.id]"
                        :key="'coverage-section-station-'+index"
                        :span="24"
                        class="my-2"
                    >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                {{ item.function }}
                            </el-col>
                            <el-col :span="12" class="text-center">
                                <span class="mr-4">
                                    <!-- <img
                                        src="../../../../../assets/icons/edit-icon.svg"
                                        width="12"
                                        class="cursor-pointer"
                                        @click="editActivity(
                                            item.activity_list,
                                            item.transaction_list,
                                            item.daily_list,
                                            item.function_id,
                                            item.department,
                                            item.hrsList,
                                            item,
                                            null
                                        )"
                                    /> -->
                                    <img
                                        src="../../../../../assets/icons/edit-icon.svg"
                                        width="12"
                                        class="cursor-pointer"
                                        @click="editCombinedNonCoverageActivity(item)"
                                    />
                                </span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col v-if="JSON.stringify(groupedCoverageSections[store_section_details.id]) === '{}'" :span="24" class="my-2">
                        No station attached
                    </el-col>
                </el-row>
                <el-row
                    v-if="!groupedCoverageSections[store_section_details.id] || JSON.stringify(groupedCoverageSections[store_section_details.id]) === '{}'"
                    :gutter="20"
                >
                    <el-col :span="24" class="my-2">
                        No station attached
                    </el-col>
                </el-row>
            </el-col>
            <el-col
                :span="12"
            >
                <h4 class="mb-2">Non-coverage Activities</h4>
                <el-row
                    v-if="groupedNonCoverageSections[store_section_details.id]"
                    :gutter="20"
                    style="max-height: 400px; overflow-y: auto;"
                >
                    <el-col
                        v-for="(item, index) in groupedNonCoverageSections[store_section_details.id]"
                        :key="'coverage-section-station-'+index"
                        :span="24"
                        class="my-2"
                    >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                {{ getFunctionName(item.function) }}
                            </el-col>
                            <el-col :span="12" class="text-center">
                                <span class="mr-4">
                                    <img
                                        src="../../../../../assets/icons/edit-icon.svg"
                                        width="12"
                                        class="cursor-pointer"
                                        @click="editCombinedNonCoverageActivity(item)"
                                    />
                                    <!-- <img
                                        src="../../../../../assets/icons/edit-icon.svg"
                                        width="12"
                                        class="cursor-pointer"
                                        @click="openEditSectionNonCoverageActivity(item)"
                                    /> -->
                                    <!-- <img
                                        src="../../../../../assets/icons/edit-icon.svg"
                                        width="12"
                                        class="cursor-pointer"
                                        @click="hide_show_non_coverage_activity = true"
                                    /> -->
                                </span>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col
                        v-if="JSON.stringify(groupedNonCoverageSections[store_section_details.id]) === '{}'"
                        :span="24"
                        class="my-2"
                    >
                        No station attached
                    </el-col>
                </el-row>
                <el-row
                    v-else-if="!groupedCoverageSections[store_section_details.id] || JSON.stringify(groupedCoverageSections[store_section_details.id]) === '{}'"
                    :gutter="20"
                >
                    <el-col :span="24" class="my-2">
                        No station attached
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <span slot="footer">
			<el-row :gutter="20">
				<el-col :span="24" class="text-right">
					<el-button
						type="warning"
						size="small"
						class="primary-settings-button__save"
						round
						@click="saveStoreSectionDetails"
					>Save</el-button>
				</el-col>
			</el-row>
		</span>
    </el-dialog>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
export default {
    name: "StoreSectionEditModal",
    mixins: [settingsMixin],
}
</script>

<style lang="scss">
.store-settings .store-section-edit-modal {
	position: absolute;
	right: 0;
	height: 100vh;
	overflow: auto;
	.el-dialog__header {
		display: none;
	}
	.primary-text {
		color: #f9a168;
	}
	.secondary-text {
		color: #999999;
	}
	.custom-scroll-area__wrapper {
		max-height: 250px;
		overflow-y: auto;
		overflow-x: auto;
		::-webkit-scrollbar {
			-webkit-appearance: none !important;
			width: 7px !important;
		}

		::-webkit-scrollbar-thumb {
			border-radius: 4px !important;
			background-color: rgba(0, 0, 0, .5) !important;
			box-shadow: 0 0 1px rgba(255, 255, 255, .5) !important;
		}
	}
    .custom-flex {
        display: flex;
    }
    .section-name {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        color: #333333;
        margin-right: 15px;
    }
    .el-table th.el-table__cell > .cell {
		text-align: left !important;
	}
}
</style>